// extracted by mini-css-extract-plugin
export var active = "_1x-9";
export var backButton = "_1x-8";
export var clone = "_1x-e";
export var collapseBar = "_1x-k";
export var collapseMode = "_1x-m";
export var collapsed = "_1x-o";
export var dimmed = "_1x-i";
export var dragHandle = "_1x-c";
export var dropdownIcon = "_1x-g";
export var expanding = "_1x-n";
export var hidden = "_1x-x";
export var iconContainer = "_1x-q";
export var iconSwapper = "_1x-w";
export var navItem = "_1x-6";
export var navItemIcon = "_1x-f";
export var navProfile = "_1x-7";
export var notificationCountBadge = "_1x-j";
export var notificationDot = "_1x-r";
export var optionsContainer = "_1x-h";
export var primaryNav = "_1x-0";
export var primaryNavDivider = "_1x-v";
export var primaryNavResizeHandle = "_1x-2";
export var primaryNavResizing = "_1x-1";
export var primaryNavTabSection = "_1x-u";
export var primaryTab = "_1x-p";
export var primaryTabIconBox = "_1x-s";
export var secondaryNav = "_1x-3";
export var selected = "_1x-t";
export var settingsNav = "_1x-4";
export var settingsNavItems = "_1x-5";
export var show = "_1x-d";
export var sideNav = "_1x-l";
export var teamItem = "_1x-a";
export var userProfileItem = "_1x-b";